import { createKeyFactory } from '@clouway/query'

export const oauthClientsKeys = createKeyFactory('oauthClients')

export const oauthClientsListKey = () => oauthClientsKeys.list()

// Own namespace, not nested under `oauthClients` — a description/status edit
// invalidating oauthClientsKeys.all() (prefix `['oauthClients']`) would
// otherwise also refetch the ceiling unnecessarily. Mirrors the users/
// serviceAccounts features' access-key split (see their keyFactory.ts).
export const oauthClientAccessKeys = createKeyFactory('oauthClientAccess')

export const oauthClientAllowedScopesKey = (id: string) => oauthClientAccessKeys.custom('allowedScopes', id)
